import { Button } from '@mui/material';
import PropTypes from 'prop-types';

export const reportTemplateTableColumns = (
  handleOpenEdit,
  handleOpenDelete
) => [
  {
    accessorKey: 'id',
    header: 'ID',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'title',
    header: 'Title',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'orgId',
    header: 'Org ID',
    enableSorting: false,
    enableColumnFilter: false,
  },
  {
    accessorKey: 's3FilePath',
    header: 'Template PDF',
    filterVariant: 'textField',
  },
  {
    accessorKey: 'details',
    header: 'Details',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return detailsCell({ renderedCellValue, handleOpenEdit });
    },
  },
  {
    accessorKey: 'delete',
    header: 'Delete',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return deleteCell({ renderedCellValue, handleOpenDelete });
    },
  },
];

const detailsCell = ({ renderedCellValue, handleOpenEdit }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        handleOpenEdit(renderedCellValue);
      }}>
      Details
    </Button>
  );
};

detailsCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenEdit: PropTypes.func.isRequired,
};

const deleteCell = ({ renderedCellValue, handleOpenDelete }) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={() => {
        handleOpenDelete(renderedCellValue.id);
      }}>
      Delete
    </Button>
  );
};

deleteCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenDelete: PropTypes.func.isRequired,
};
